const Shimmer = () => {
  return (
    <div className="flex flex-wrap">
    <div className="m-4 p-4 w-[250px] h-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    <div className="m-4 p-4 w-[250px] rounded-lg bg-gray-100"></div>
    </div>
  )
}

export default Shimmer;
